// extracted by mini-css-extract-plugin
export default {"PromoBanners":"PromoBanners_PromoBanners__w9lrr","Banner":"PromoBanners_Banner__1QUjV"};